import {giantPumpkin} from '../../data/guides/giant-pumpkin.mjs';
const origin = 'https://uogorod.ru';
const indexUrl = `${origin}/manuals`;
export const indexDescription = 'Выберите растение и то, что происходит с ним сейчас. Главное — на странице, подробности — по нажатию.';

export function guideUrl(slug) {
  return `${indexUrl}/${encodeURIComponent(slug)}`;
}

// Use the same published entries and ordering as the visible directory.
export function publishedGuides(manuals, guides) {
  return manuals.map(manual => ({manual, guide: guides.find(g => g.manualId === manual.id)})).filter(item => item.guide);
}

function breadcrumbs(url, title, parentSlug) {
  const items = [{name:'Главная', item:origin + '/'}, {name:'Руководства', item:indexUrl}];
  if(parentSlug)items.push({name:'Тыква',item:guideUrl(parentSlug)});
  if (url !== indexUrl) items.push({name:title, item:url});
  return {'@type':'BreadcrumbList', '@id':url + '#breadcrumbs', itemListElement:items.map((item, i) => ({'@type':'ListItem', position:i + 1, ...item}))};
}

export function indexSchema(items) {
  return {'@context':'https://schema.org', '@graph':[
    {'@type':'CollectionPage', '@id':indexUrl + '#webpage', url:indexUrl, name:'Руководства по выращиванию', description:indexDescription, inLanguage:'ru-RU', breadcrumb:{'@id':indexUrl + '#breadcrumbs'}, mainEntity:{'@id':indexUrl + '#cultures'}},
    breadcrumbs(indexUrl),
    {'@type':'ItemList', '@id':indexUrl + '#cultures', name:'Что вы выращиваете?', numberOfItems:items.length, itemListElement:items.map(({manual}, i) => ({'@type':'ListItem', position:i + 1, name:manual.category.title, url:guideUrl(manual.category.slug)}))}
  ]};
}

export function guideMetadata(guide) {
  const tomato = guide.slug === 'tomat';
  const giant = guide.slug === 'tykva-gigantskaya';
  return {
    title:`${guide.title} — руководство по выращиванию`,
    headline:tomato ? 'Томаты: что делать сейчас' : giant ? giantPumpkin.title : guide.title,
    description:tomato ? 'Найдите свою фазу. Проверьте условия, сделайте главное и посмотрите, как растение отвечает на уход.' : guide.intro,
    image:guide.image
  };
}

export function cropSchema(guide, phases) {
  const url = guideUrl(guide.slug);
  const giant=guide.slug==='tykva-gigantskaya';
  const {headline, description, image} = guideMetadata(guide);
  const article = {
    '@type':'Article', '@id':url + '#article', url, headline, description,
    inLanguage:'ru-RU', mainEntityOfPage:{'@id':url + '#webpage'},
    publisher:{'@type':'Organization', name:'Умный огород', url:origin + '/'},
    about:{'@type':'Thing', name:guide.title}, articleSection:'Руководства по выращиванию',
    hasPart:phases.map(phase => ({'@type':'WebPageElement', name:phase.name, url:url + '?phase=' + encodeURIComponent(guide.slug === 'tomat' ? phase.id : phase.urlId) + '#' + (guide.slug === 'tomat' ? 'tomato-' + phase.id : giant ? 'giant-'+phase.id : 'draft-' + phase.urlId)}))
  };
  // No invented author, publication dates, ratings, crop duration or placeholder image.
  if (image) article.image = new URL(image, origin).href;
  return {'@context':'https://schema.org', '@graph':[
    {'@type':'WebPage', '@id':url + '#webpage', url, name:headline, description, inLanguage:'ru-RU', isPartOf:{'@id':guide.parentSlug?guideUrl(guide.parentSlug)+'#webpage':indexUrl + '#webpage'}, breadcrumb:{'@id':url + '#breadcrumbs'}, mainEntity:{'@id':url + '#article'}},
    breadcrumbs(url, guide.title,guide.parentSlug), article
  ]};
}

// Prevent data from closing the inline script. JSON escapes retain the original text.
export function serializeSchema(value) {
  return JSON.stringify(value).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
